import React, { useEffect, useState } from 'react';
import { Form, Input, Select, Button, message, Spin } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

interface InsumoData {
  id: number;
  descripcion: string;
  clasificacion: number;
}

const EditarObjetos: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { user } = useAuth0();
  const empresa = user?.id_empresa;
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);

  // Cargar los datos del insumo seleccionado
  useEffect(() => {
    const fetchInsumo = async () => {
      setLoading(true);
      try {
        const accessToken = await getAccessTokenSilently();
        const url = `${process.env.REACT_APP_INSUMOS_URL}/editar_objetos/${empresa}/${id}`;
        console.log('URL de fetch:', url);
        console.log('Valores enviados:', { empresa, id });
        
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${accessToken}`,
          },
        });

        if (!response.ok) {
          throw new Error('Error al cargar el insumo');
        }

        const data = await response.json();
        console.log('data_objeto', data);
        // Establecer los valores en el formulario
        form.setFieldsValue({
          descripcion: data.descripcion,
          clasificacion: data.clasificacion,
        });
      } catch (error) {
        console.error('Error:', error);
        message.error('Error al cargar los datos del insumo');
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchInsumo();
    }
  }, [id, form, getAccessTokenSilently, empresa]);

  const onFinish = async (values: any) => {
    setButtonLoading(true);
    try {
      const accessToken = await getAccessTokenSilently();
      const url = `${process.env.REACT_APP_INSUMOS_URL}/editar_objetos/${empresa}/${id}`;
      console.log('URL de actualización:', url);
      console.log('Datos enviados:', { ...values, empresa, id });
      
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify(values),
      });

      if (!response.ok) {
        throw new Error('Error al actualizar el insumo');
      }

      message.success('Insumo actualizado correctamente');
      navigate('/listar_objetos');
    } catch (error) {
      console.error('Error:', error);
      message.error('Error al actualizar el insumo');
    } finally {
      setButtonLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <div style={{ textAlign: 'center', margin: '20px' }}>
          <Spin tip="Cargando datos..." />
        </div>
      ) : (
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          style={{ maxWidth: 600, margin: '20px auto' }}
        >
          <Form.Item
            name="descripcion"
            label="Descripción"
            rules={[{ required: true, message: 'Por favor ingrese la descripción' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="clasificacion"
            label="Clasificación"
            rules={[{ required: true, message: 'Por favor seleccione la clasificación' }]}
          >
            <Select>
              <Select.Option value={1}>Grupo</Select.Option>
              <Select.Option value={2}>SubGrupo</Select.Option>
              <Select.Option value={3}>Marca</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item>
            <Button 
            type="primary"
             htmlType="submit" 
             loading={buttonLoading}
             disabled={buttonLoading}
             >
              {buttonLoading ? 'Actualizando...' : 'Actualizar'}
            </Button>
            <Button 
              style={{ marginLeft: 8 }} 
              onClick={() => navigate('/listar_objetos')}
            >
              Listar
            </Button>
          </Form.Item>
        </Form>
      )}
    </>
  );
};

export default EditarObjetos;